<template>
  <div>
    <div class="page-content py-5">
      <div class="container" >
        <full-cart  v-if="site_info.donations_allowed == true"></full-cart>
        
        <div v-else class="alert alert-danger" role="alert">
          {{ $t("message.donations_not_allowed") }}
        </div>
       
      </div>
     
    </div>
  </div>
</template>
<script>
import {   mapGetters } from "vuex";
import FullCart from "../components/FullCart.vue";
export default {
  name: "CartPage",
  components: { FullCart },
  computed: {
    ...mapGetters("site", ["site_info"]),
  },
  metaInfo() {
    return {
      titleTemplate: this.$t("title.fullCart") + " | %s",
      meta: [
        {
          vmid: "og:title",
          property: "og:title",
          content: this.$t("title.fullCart"),
        },
      ],
    };
  },
};
</script>